export const responsesTokenExpired = ['Unauthorized', 'The incoming token has expired'];
export const NUMBER_OF_API_RETRIES = 5;
